import { Injectable, PipeTransform } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { debounceTime, delay, switchMap, tap } from 'rxjs/operators';
import { DecimalPipe } from '@angular/common';

import { SortDirection } from '../directives/sortable.directive';

interface SearchResult {
  dealers: any[];
  total: number;
}

interface PageItem {
  values: number;
  label: string;
}

interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortColumn: string;
  sortDirection: SortDirection;
  dataSource: any[];
  searchby: any[];
}
function compare(v1, v2) {
  return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
}

function sort(dealers: any[], column: string, direction: string): any[] {
  if (direction === '') {
    return dealers;
  } else {
    return [...dealers].sort((a, b) => {
      const res = compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
}

function matches(dealer: any, term: any, serBy: any, pipe: PipeTransform) {
  return serBy.find(serch => {
    if (dealer[serch] !== null) {
      return dealer[serch].toString().toLowerCase().replace(/\s/g,'').includes((term !== '' ? term.toString().toLowerCase().replace(/\s/g,'') : ''))
    }
  });
}

@Injectable({
  providedIn: 'root'
})
export class CustomPaggerService {
  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  public _dealers$ = new BehaviorSubject<any[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  private _perPageItems: PageItem[] = [
    { values: 5, label: 'lbl5ItemsPerPage' },
    { values: 10, label: 'lbl10ItemsPerPage' },
    { values: 20, label: 'lbl20ItemsPerPage' },
    { values: 50, label: 'lbl50ItemsPerPage' }
  ];
  private _state: State = {
    page: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: '',
    sortDirection: '',
    dataSource: [],
    searchby: []
  };
private _searchResult:SearchResult={
  dealers:[],
  total:0
}
  constructor(private pipe: DecimalPipe) {
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      debounceTime(200),
      switchMap(() => this._search()),
      delay(200),
      tap(() => this._loading$.next(false))
    ).subscribe(result => {
      this._dealers$.next(result.dealers);
      this._total$.next(result.total);
    });

    this._search$.next();
  }

  get dealers$() { return this._dealers$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }
  get pageItemsArray() { return this._perPageItems.slice(); }
  get data() { return this._state.dataSource;}
  get serachResult(){return this._searchResult.dealers}

  set dealers$(dealers$: any) { this._dealers$ = dealers$; }
  set total$(total$: any) { this._total$ = total$; }
  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set searchTerm(searchTerm: string) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: string) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }
  set dataSource(dataSource: any[]) { this._set({ dataSource }); }
  set searchby(searchby: any[]) { this._set({ searchby }); }


  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  private _search(): Observable<SearchResult> {

    const { sortColumn, sortDirection, pageSize, page, searchTerm, dataSource, searchby } = this._state;

    // 1. sort
    let dealers = sort(dataSource, sortColumn, sortDirection);

    // 2. filter
    dealers = (searchby.length > 0 && searchTerm !== '') ?
      dealers.filter(column => matches(column, searchTerm, searchby, this.pipe)) : dealers;
    const total = dealers ? dealers.length : 0;
    this._searchResult.dealers = dealers;
    this._searchResult.total = total
    // 3. paginate
    let currentPage = page;
    if (dealers) {
      const pageCount = Math.ceil(dealers.length / pageSize);
      if (pageCount < page && (searchby.length > 0 && searchTerm !== '')) { currentPage = 1; this.page = currentPage; }
    }
    dealers = dealers ? dealers.slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize) : [];
    return of({ dealers, total });
  }
}
